import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ZipCodePipe } from '../pipes/zip-code.pipe';

@Directive({
  selector: '[zipCode]',
  standalone: true
})
export class ZipCodeDirective {
  private numberPattern = '[0-9]';

  constructor(private elRef: ElementRef, private ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event']) onModelChange(event) {
    const zipPipe = new ZipCodePipe();
    this.ngControl.valueAccessor.writeValue(zipPipe.transform(event));
  }

  // Block on keypress
  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.numberPattern).test(event.key);
  }

  // Block on copy/paste
  @HostListener('paste', ['$event']) blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  private validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData
      .getData('text/plain')
      .replace(/[^0-9]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
